import { shape, number } from 'prop-types';

export default shape({
    listingOffset: number,
    firstPageLength: number,
    nbResultPerPage: number,
});
